export default __webpack_public_path__ + "static/media/SomethingWentWrongAlert.08f975f6.svg";